<ng-container>

  <div>
    <b>{{ name }}</b>
    <app-info class="formGroupLabel" [wide]="false" [placement]="'left'">
      <div class="tooltipContent">
        <b>Considering</b>
        <ul>
          @for (consider of splitConsidering(); track consider) {
            <div>
              <li>
                {{ consider }}
              </li>
            </div>
          }
        </ul>
      </div>
    </app-info>
  </div>

  <ng-container>
    <div class="row">
      <div class="col-md fieldset">
        <app-visit-exemptions-exemption-common [exemption]="exemption"></app-visit-exemptions-exemption-common>

        <div class="row">
          <app-form-group label="Reason for request for exemption">
            <app-select id="reasonType" [(ngModel)]="exemption.reasonType" (ngModelChange)="resetReasonType()"
                        [options]="reasonTypes" required>
            </app-select>
          </app-form-group>
        </div>
      </div>

      <div class="col-md fieldset">
        <div class="row">
          <app-form-group label="(2nd) Vessel type">
            <app-select [(ngModel)]="exemption.secondVesselType" (ngModelChange)="resetVesselInfoSecond()"
                        id="secondVesselType" [options]="vesselTypes"
                        [formatter]="vesselTypesFormatter" [required]="this.secondVesselRequired(exemption.reasonType)">
            </app-select>
          </app-form-group>
          @if (exemption.secondVesselType === 'IMO') {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>(2nd) Name/IMO number</label>
                <div class="tooltipContent">Name of additional vessel; only applicable if berth dimensions are exceeded
                  by
                  mooring additional vessel.
                </div>
              </app-info>
              <app-search [(ngModel)]="secondVessel" (ngModelChange)="onVesselChangeWithPrefix('second', secondVessel)"
                          [searchFunction]="searchVessel" [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="secondVessel">
              </app-search>
            </app-form-group>
          }
          @if (exemption.secondVesselType === 'IMO') {
            <app-form-group label="(2nd) Name">
              <input [(ngModel)]="exemption.secondVesselNameIMO" id="secondVesselNameIMO" type="text"
                     maxlength="64" class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.secondVesselType === 'IMO') {
            <app-form-group label="(2nd) IMO number">
              <input [(ngModel)]="exemption.secondVesselIMO" id="secondVesselIMO" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.secondVesselType === 'ENI') {
            <app-form-group label="(2nd) Name">
              <input [(ngModel)]="exemption.secondVesselNameENI" id="secondVesselNameENI" type="text"
                     maxlength="64" class="form-control" required>
            </app-form-group>
          }
          @if (exemption.secondVesselType === 'ENI') {
            <app-form-group label="(2nd) ENI number">
              <input [(ngModel)]="exemption.secondVesselENI" id="secondVesselENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
          @if (exemption.secondVesselType) {
            <app-form-group label="(2nd) Arrival">
              <app-date-field [(ngModel)]="exemption.secondVesselArrival" id="secondVesselArrival"
                              required></app-date-field>
            </app-form-group>
          }
          @if (exemption.secondVesselType) {
            <app-form-group label="(2nd) Departure">
              <app-date-field [(ngModel)]="exemption.secondVesselDeparture" id="secondVesselDeparture"
                              required></app-date-field>
            </app-form-group>
          }
        </div>

        <div class="row">
          @if (exemption.secondVesselType) {
            <app-form-group label="(3rd) Vessel type">
              <app-select [(ngModel)]="exemption.thirdVesselType" (ngModelChange)="resetVesselInfoThird()"
                          id="thirdVesselType" [options]="vesselTypes"
                          [formatter]="vesselTypesFormatter">
              </app-select>
            </app-form-group>
          }
          @if (exemption.thirdVesselType === 'IMO') {
            <app-form-group>
              <app-info class="formGroupLabel">
                <label>(3rd) Name/IMO number</label>
                <div class="tooltipContent">Name of additional vessel; only applicable if berth dimensions are exceeded
                  by
                  mooring additional vessel.
                </div>
              </app-info>
              <app-search [(ngModel)]="thirdVessel" (ngModelChange)="onVesselChangeWithPrefix('third', thirdVessel)"
                          [searchFunction]="searchVessel" [inputFormatter]="vesselNameFormatter"
                          [minCharacters]="3" dataKey="imoCode" id="thirdVessel">
              </app-search>
            </app-form-group>
          }
          @if (exemption.thirdVesselType === 'IMO') {
            <app-form-group label="(3rd) Name">
              <input [(ngModel)]="exemption.thirdVesselNameIMO" id="thirdVesselNameIMO" type="text"
                     maxlength="64" class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.thirdVesselType === 'IMO') {
            <app-form-group label="(3rd) IMO number">
              <input [(ngModel)]="exemption.thirdVesselIMO" id="thirdVesselIMO" type="text" maxlength="64"
                     class="form-control" readonly required>
            </app-form-group>
          }
          @if (exemption.thirdVesselType === 'ENI') {
            <app-form-group label="(3rd) Name">
              <input [(ngModel)]="exemption.thirdVesselNameENI" id="thirdVesselNameENI" type="text"
                     maxlength="64" class="form-control" required>
            </app-form-group>
          }
          @if (exemption.thirdVesselType === 'ENI') {
            <app-form-group label="(3rd) ENI number">
              <input [(ngModel)]="exemption.thirdVesselENI" id="thirdVesselENI" type="text" maxlength="64"
                     class="form-control" required>
            </app-form-group>
          }
          @if (exemption.thirdVesselType) {
            <app-form-group label="(3rd) Arrival">
              <app-date-field [(ngModel)]="exemption.thirdVesselArrival" id="thirdVesselArrival"
                              required></app-date-field>
            </app-form-group>
          }
          @if (exemption.thirdVesselType) {
            <app-form-group label="(3rd) Departure">
              <app-date-field [(ngModel)]="exemption.thirdVesselDeparture" id="thirdVesselDeparture"
                              required></app-date-field>
            </app-form-group>
          }
        </div>

        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>Total distance (m)</label>
              <div class="tooltipContent">Largest combination of vessel(s) + possibly fendering.</div>
            </app-info>
            <input [(ngModel)]="exemption.totalDistance" id="totalDistance" type="number" maxlength="64"
                   class="form-control" required>
          </app-form-group>
        </div>

        <div class="row">
          @if (exemption.reasonType == MOORING_ALONGSIDE) {
            <app-form-group
              label="What kind of activity will take place ?">
              <app-select id="reasonTypeActivity" [(ngModel)]="exemption.reasonTypeActivity"
                          (ngModelChange)="resetActivityTypeDescription()"
                          [options]="activityTypes" required>
              </app-select>
            </app-form-group>
          }
        </div>
        <div class="row">
          @if (exemption.reasonType == MOORING_ALONGSIDE && exemption.reasonTypeActivity == OTHER) {
            <app-form-group label="Other reason (Activity)"
            >
              <input [(ngModel)]="exemption.reasonTypeActivityDescription" id="reasonTypeActivityDescription"
                     type="text" minlength="10" maxlength="64" class="form-control" required>
            </app-form-group>
          }
        </div>

        <div class="row">
          @if (exemption.reasonType == MOORING_ALONGSIDE) {
            <app-form-group
              label="Which vessel(s) is/are also part of exceedance (in addition to those specified ?)">
              <app-select id="reasonTypeVessel" [(ngModel)]="exemption.reasonTypeVessel"
                          (ngModelChange)="resetVesselTypeDescription()"
                          [options]="otherVesselTypes" required>
              </app-select>
            </app-form-group>
          }
        </div>
        <div class="row">
          @if (exemption.reasonType == MOORING_ALONGSIDE && exemption.reasonTypeVessel == OTHER) {
            <app-form-group label="Other vessel"
            >
              <input [(ngModel)]="exemption.reasonTypeVesselDescription" id="reasonTypeVesselDescription" type="text"
                     minlength="10" maxlength="64" class="form-control" required>
            </app-form-group>
          }
        </div>

        <div class="row">
          <app-form-group
            label="To guarantee passage to surrounding (shore) companies, I agree with the liability for all costs likely to be incurred owing to berth dimensions being exceeded">
            <app-yes-no [(ngModel)]="exemption.agreedWithTheLiability" id="agreedWithTheLiability"
                        required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group>
            <app-info class="formGroupLabel">
              <label>The shore-based business(es) have been informed in advance by or on behalf of me (the applicant)
                (if there is a reduced accessibility for surrounding (shore-based) businesses as a result of the
                proposed exceedance), and have also agreed to the reduced accessibility</label>
              <div class="tooltipContent">
                Specify the business(es) in the 'Details'
              </div>
            </app-info>
            <app-yes-no [(ngModel)]="exemption.haveBusinessesBeenInformed" id="haveBusinessesBeenInformed"
                        required></app-yes-no>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="I agree to cooperate fully if shifting is deemed necessary to guarantee passage">
            <app-yes-no [(ngModel)]="exemption.agreedToCooperate" id="agreedToCooperate" required></app-yes-no>
          </app-form-group>
        </div>
        <div class="row">
          <app-form-group
            label="From the moment permission has been withdrawn by the HCC, the captain or skipper must ensure that the established maximum permitted width is restored within a maximum time-scale of 2 hours, or by a time to be specified by the HCC">
            <app-yes-no [(ngModel)]="exemption.permittedWidthRestored" id="permittedWidthRestored"
                        required></app-yes-no>
          </app-form-group>
        </div>

        <div class="row">
          <app-form-group label="Details">
            <textarea [(ngModel)]="exemption.details" id="details" type="text" rows="3" maxlength="256"
                      class="form-control"></textarea>
          </app-form-group>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>
